/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u3m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How long is a 3-minute egg really?`)
};

const es_timer_u3m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo es realmente un huevo de 3 minutos?`)
};

const de_timer_u3m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie ist ein 3-Minuten-Ei wirklich?`)
};

const nl_timer_u3m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe gaar is een ei van 3 minuten echt?`)
};

const fr_timer_u3m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À quoi correspond réellement un œuf cuit 3 minutes ?`)
};

const it_timer_u3m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto dura davvero un uovo cotto per 3 minuti?`)
};

const pt_br2_timer_u3m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto tempo é realmente um ovo de 3 minutos?`)
};

const pt_timer_u3m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto tempo dura mesmo um ovo de 3 minutos?`)
};

const ja_timer_u3m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3分ゆで卵は実際どのような状態になりますか？`)
};

const zh_timer_u3m_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3分钟煮出来的鸡蛋到底是什么状态？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u3m_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u3m_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u3m_faq3_q", locale)
	if (locale === "en") return en_timer_u3m_faq3_q(inputs)
	if (locale === "es") return es_timer_u3m_faq3_q(inputs)
	if (locale === "de") return de_timer_u3m_faq3_q(inputs)
	if (locale === "nl") return nl_timer_u3m_faq3_q(inputs)
	if (locale === "fr") return fr_timer_u3m_faq3_q(inputs)
	if (locale === "it") return it_timer_u3m_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u3m_faq3_q(inputs)
	if (locale === "pt") return pt_timer_u3m_faq3_q(inputs)
	if (locale === "ja") return ja_timer_u3m_faq3_q(inputs)
	return zh_timer_u3m_faq3_q(inputs)
};